import { Component } from 'react';

// Zachytí runtime chyby i selhání načtení JS/CSS částí (typicky stará cache po
// novém nasazení). Místo prázdné bílé stránky buď jednou automaticky obnoví
// (aby stáhl aktuální soubory), nebo ukáže srozumitelnou hlášku s tlačítky.
import { isChunkError, reloadForNewVersion } from '../lib/chunkReload';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Stará verze odkazuje na neexistující soubory → obnovit pro čerstvé (viz lib/chunkReload.js)
    if (isChunkError(error) && reloadForNewVersion()) return;
    // eslint-disable-next-line no-console
    console.error('App error boundary:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', textAlign: 'center', padding: '24px',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%', background: '#F0FDF4',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 16,
        }}>🌿</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1B4332', margin: '0 0 8px' }}>
          Stránku se nepodařilo načíst
        </h1>
        <p style={{ color: '#4b5563', margin: '0 0 22px', maxWidth: 440, lineHeight: 1.6 }}>
          Zkuste stránku obnovit. Pokud problém přetrvává, klidně nám rovnou zavolejte – rádi pomůžeme.
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={this.handleReload} style={{
            background: '#3FA34D', color: '#fff', border: 'none', borderRadius: 999,
            padding: '12px 26px', fontWeight: 600, fontSize: 15, cursor: 'pointer',
          }}>Obnovit stránku</button>
          <a href="tel:+420730588372" style={{
            border: '2px solid #3FA34D', color: '#1B4332', borderRadius: 999,
            padding: '10px 26px', fontWeight: 600, fontSize: 15, textDecoration: 'none',
          }}>Zavolat 730 588 372</a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
